import { createStyles } from "@material-ui/core";

export const styles = createStyles({
  deviceIcon: {
    backgroundColor: "transparent"
  }
});